import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Sparkles, ArrowLeft, Clock } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import ResultCard from '../components/ResultCard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HistoryPage = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await axios.get(`${API}/search/history`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setHistory(response.data);
    } catch (error) {
      toast.error('Failed to load history');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-background to-black">
      <nav className="border-b border-border/50 backdrop-blur-md bg-card/30">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Sparkles className="text-primary" size={28} />
            <h1 className="text-2xl font-heading font-bold text-foreground">
              concurrenz<span className="text-primary">.AI</span> - History
            </h1>
          </div>
          <Button data-testid="back-button" onClick={() => navigate('/search')} variant="ghost">
            <ArrowLeft size={20} className="mr-2" />
            Back to Search
          </Button>
        </div>
      </nav>

      <main className="max-w-5xl mx-auto px-6 py-12">
        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin text-primary">
              <Sparkles size={32} />
            </div>
            <p className="mt-4 text-muted-foreground">Loading your history...</p>
          </div>
        ) : history.length === 0 ? (
          <Card className="p-12 text-center rounded-xl border bg-card/50 backdrop-blur-md" data-testid="empty-history">
            <Clock className="mx-auto text-muted-foreground mb-4" size={48} />
            <h3 className="text-xl font-heading font-semibold text-foreground mb-2">No Search History Yet</h3>
            <p className="text-muted-foreground mb-6">Start searching to build your history</p>
            <Button data-testid="start-searching-button" onClick={() => navigate('/search')} className="rounded-full px-6">
              Start Searching
            </Button>
          </Card>
        ) : (
          <div className="space-y-6" data-testid="history-list">
            {history.map((item, idx) => (
              <div key={item.id} data-testid={`history-item-${idx}`}>
                <ResultCard result={item} />
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default HistoryPage;